module.exports = __webpack_public_path__ + "static/media/office_created_icon.27e96689.svg";